import {
  pgTable, uuid, text, timestamp, integer, bigint, index,
} from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

// ---------------------------------------------------------------------------
// Forecast Snapshots + Quotas (S.5)
// ---------------------------------------------------------------------------

export const FORECAST_CATEGORIES = ["commit", "best_case", "pipeline", "omitted"] as const;
export type ForecastCategory = (typeof FORECAST_CATEGORIES)[number];

export const QUOTA_METRIC_TYPES = [
  "revenue", "deals_closed", "bookings_completed", "calls_made",
] as const;
export type QuotaMetricType = (typeof QUOTA_METRIC_TYPES)[number];

export const forecastSnapshots = pgTable("forecast_snapshots", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  period: text("period").notNull(), // "2026-03" for monthly
  snapshotDate: timestamp("snapshot_date", tz).notNull(),
  category: text("category").notNull(), // ForecastCategory
  totalAmountCents: bigint("total_amount_cents", { mode: "number" }).notNull(),
  dealCount: integer("deal_count").notNull(),
  currency: text("currency").notNull().default("EUR"),
  createdAt: timestamp("created_at", tz).notNull().defaultNow(),
}, (table) => [
  index("idx_forecast_tenant_period").on(table.tenantId, table.period),
]);

export const quotas = pgTable("quotas", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  staffUserId: uuid("staff_user_id").notNull(),
  period: text("period").notNull(), // "2026-03"
  metricType: text("metric_type").notNull(), // QuotaMetricType
  targetValue: bigint("target_value", { mode: "number" }).notNull(),
  actualValue: bigint("actual_value", { mode: "number" }).notNull().default(0),
  currency: text("currency"), // for revenue quotas
  createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
}, (table) => [
  index("idx_quotas_tenant_staff").on(table.tenantId, table.staffUserId, table.period),
]);
